<app-menu class="menuApp"></app-menu>
<div class="main">
  <div style="width: 90%; margin: auto;">
    <div class="row deviceSection">
      <div class="deviceHeader">
        <h3 class="centerVert textXXM">{{this.localiser.get("reports.title")}}</h3>
      </div>
    </div>

    <div class="row" style="width: 90%; margin: auto">

      <div class="col-3" style="margin: auto">
        <mat-select class="upperButton textS" (selectionChange)="selectMonth($event.value)" [(ngModel)]="monthSelected">
          <mat-option class="textS" *ngFor="let month of showMonths"
                      [value]="months.indexOf(month)">{{this.localiser.get(month)}}</mat-option>
        </mat-select>
      </div>
      <div class="col-3" style="margin: auto">
        <mat-select class="upperButton textS" (selectionChange)="selectYear($event.value)" [(ngModel)]="yearSelected">
          <mat-option class="textS" *ngFor="let year of years" [value]="years.indexOf(year)">{{year}}</mat-option>
        </mat-select>
      </div>
      <div style="margin: 1vh">
        <mat-checkbox id="monthlyReportCheck" [(ngModel)]="monthlyReportCheck" (change)="setCheck($event)" style="width: 70%; margin-left: 10%; margin-top: 4%">
          <h1 class="textS marginAuto" style="white-space: break-spaces">{{this.localiser.get("reports.checkSendReports")}}</h1>
        </mat-checkbox>
      </div>
      <div style="margin: 1vh">
        <button (click)="selectionForPrint()" class="buttonPrint">
          <span class="material-icons-outlined customIcon textXM">print</span>
          <h4 class="textS" style="margin: auto">{{this.localiser.get("reports.print")}}</h4>
        </button>
      </div>
      <div style="margin: 1vh">
        <button (click)="openConfigure()" class="buttonSettings">
          <span class="material-icons-outlined customIcon textXM">settings</span>
        </button>
      </div>
    </div>

    <!-- PROYECTS LIST -->
    <div *ngFor="let proyect of user.getProyectos()">
      <div class="row marginAuto"
            style="width: 90%; height: 10vh; margin-top: 2vh; border-bottom: 2px solid #18264f">

        <!-- BUTTON HIDE -->
        <div class="col-1" style="text-align: center">
          <div (click)="openProyect(proyect)" class="expandButton centerVert" style="height: 80%">
            <span class="material-icons-outlined customRowIcon textL"
                  [ngClass]="{'expandButtonRotate': proyectsClicked[this.user.getProyectos().indexOf(proyect)],
                   'expandButtonNormal': !proyectsClicked[this.user.getProyectos().indexOf(proyect)]}">expand_more</span>
          </div>
        </div>

        <!-- PROYECT NAME -->
        <div class="col-3">
          <h3 class="centerVert textS+ truncateText">{{proyect.nombre}}</h3>
        </div>

        <!-- TODAY CONSUMPTION -->
        <div class="col-2 marginAuto" style="height: 100%">
          <div class="row" style="height: 45%">
            <h3 class="textXS marginAuto">{{this.localiser.get("reports.today")}}</h3>
          </div>
          <div *ngIf="zonas[this.user.getProyectos().indexOf(proyect)].length == 0 || !this.isActualMonth()" class="row">
            <h3 class="textS marginAuto">--</h3>
          </div>
          <div *ngIf="zonas[this.user.getProyectos().indexOf(proyect)].length > 0 && this.isActualMonth()" class="row">
            <h3 *ngIf="consumoLoaded(proyect)" class="textS marginAuto">{{consumoSumaProyecto(proyect)[0].toFixed(2)}} kWh</h3>
            <mat-progress-spinner *ngIf="!consumoLoaded(proyect)" class="marginAuto" color="primary" mode="indeterminate" diameter="20">
            </mat-progress-spinner>
          </div>
        </div>

        <!-- WEEK CONSUMPTION -->
        <div class="col-2 marginAuto" style="height: 100%">
          <div class="row" style="height: 45%">
            <h3 class="textXS marginAuto">{{this.localiser.get("reports.week")}}</h3>
          </div>
          <div *ngIf="zonas[this.user.getProyectos().indexOf(proyect)].length == 0 || !this.isActualMonth()" class="row">
            <h3 class="textS marginAuto">--</h3>
          </div>
          <div *ngIf="zonas[this.user.getProyectos().indexOf(proyect)].length > 0 && this.isActualMonth()" class="row">
            <h3 *ngIf="consumoLoaded(proyect)" class="textS marginAuto">{{consumoSumaProyecto(proyect)[1].toFixed(2)}} kWh</h3>
            <mat-progress-spinner *ngIf="!consumoLoaded(proyect)" class="marginAuto" color="primary" mode="indeterminate" diameter="20">
            </mat-progress-spinner>
          </div>
        </div>

        <!-- MONTH CONSUMPTION -->
        <div class="col-2 marginAuto" style="height: 100%">
          <div class="row" style="height: 45%">
            <h3 class="textXS marginAuto">{{this.localiser.get("reports.month")}}</h3>
          </div>
          <div *ngIf="zonas[this.user.getProyectos().indexOf(proyect)].length == 0" class="row">
            <h3 class="textS marginAuto">--</h3>
          </div>
          <div *ngIf="zonas[this.user.getProyectos().indexOf(proyect)].length > 0" class="row">
            <h3 *ngIf="consumoLoaded(proyect)" class="textS marginAuto">{{consumoSumaProyecto(proyect)[2].toFixed(2)}} kWh</h3>
            <mat-progress-spinner *ngIf="!consumoLoaded(proyect)" class="marginAuto" color="primary" mode="indeterminate" diameter="20">
            </mat-progress-spinner>
          </div>
        </div>

        <!-- DIARY MEDIUM -->
        <div class="col-2 marginAuto" style="height: 100%">
          <div class="row" style="height: 45%">
            <h3 class="textXS marginAuto">{{this.localiser.get("reports.average")}}</h3>
          </div>
          <div *ngIf="zonas[this.user.getProyectos().indexOf(proyect)].length == 0" class="row">
            <h3 class="textS marginAuto">--</h3>
          </div>
          <div *ngIf="zonas[this.user.getProyectos().indexOf(proyect)].length > 0" class="row">
            <h3 *ngIf="consumoLoaded(proyect)" class="textS marginAuto">{{consumoMedio(consumoSumaProyecto(proyect)[2])}} kWh</h3>
            <mat-progress-spinner *ngIf="!consumoLoaded(proyect)" class="marginAuto" color="primary" mode="indeterminate" diameter="20">
            </mat-progress-spinner>
          </div>
        </div>

      </div>

      <!-- ZONE LIST -->
      <div id='tableZones' [ngClass]="{'expandedTable': proyectsClicked[this.user.getProyectos().indexOf(proyect)]}">

        <div *ngIf="zonas[this.user.getProyectos().indexOf(proyect)].length > 0" class="row marginAuto" style="text-align: center; width: 50%; height: 10%">
          <canvas [id]="canvasDynamicIdProyecto(proyect)"></canvas>
        </div>

        <div *ngFor="let zona of zonas[this.user.getProyectos().indexOf(proyect)]">
          <div class="row marginAuto"
               style="text-align: center; width: 90%; margin-top: 1vh">

            <!-- EMPTY FIRST COL -->
            <div class="col-1"></div>

            <!-- PROYECT NAME -->
            <div class="col-3" style="border-bottom: 1px solid #18264f">
              <h3 class="textS centerVert" style="text-align: left">{{zona.nombre}}</h3>
            </div>

            <!-- TODAY CONSUMPTION -->
            <div class="col-2" style="border-bottom: 1px solid #18264f">
              <h3 *ngIf="!this.isActualMonth()" class="textS centerVert marginAuto">--</h3>
              <h3 *ngIf="zona.consumo != null && this.isActualMonth()" class="textS centerVert marginAuto">{{zona.consumo.today}} Wh</h3>
              <mat-progress-spinner *ngIf="zona.consumo == null && this.isActualMonth()" class="marginAuto centerVert" color="primary" mode="indeterminate" diameter="20">
              </mat-progress-spinner>
            </div>

            <!-- WEEK CONSUMPTION -->
            <div class="col-2" style="border-bottom: 1px solid #18264f">
              <h3 *ngIf="!this.isActualMonth()" class="textS centerVert marginAuto">--</h3>
              <h3 *ngIf="zona.consumo != null && this.isActualMonth()" class="textS centerVert marginAuto">{{zona.consumo.week}} Wh</h3>
              <mat-progress-spinner *ngIf="zona.consumo == null && this.isActualMonth()" class="marginAuto centerVert" color="primary" mode="indeterminate" diameter="20">
              </mat-progress-spinner>
            </div>

            <!-- MONTH CONSUMPTION -->
            <div class="col-2" style="border-bottom: 1px solid #18264f">
              <h3 *ngIf="zona.consumo != null" class="textS centerVert marginAuto">{{consumoMonthZona(zona)}} Wh</h3>
              <mat-progress-spinner *ngIf="zona.consumo == null" class="marginAuto centerVert" color="primary" mode="indeterminate" diameter="20">
              </mat-progress-spinner>
            </div>

            <!-- DIARY MEDIUM -->
            <div class="col-2" style="border-bottom: 1px solid #18264f">
              <h3 *ngIf="zona.consumo != null" class="textS centerVert marginAuto">{{consumoMedio(consumoMonthZona(zona))}} Wh</h3>
              <mat-progress-spinner *ngIf="zona.consumo == null" class="marginAuto centerVert" color="primary" mode="indeterminate" diameter="20">
              </mat-progress-spinner>
            </div>

          </div>

          <div class="row marginAuto" style="text-align: center; width: 50%; height: 10%">
            <canvas [id]="canvasDynamicIdZona(zona)"></canvas>
          </div>
        </div>

        <!-- IF THERE ARE NO ZONES -->
        <div *ngIf="zonas[this.user.getProyectos().indexOf(proyect)].length == 0" class="row marginAuto" style="width: 90%; height: 4vh; margin-top: 1vh">
          <div class="col-1">

          </div>
          <div class="col-3" style="border-bottom: 1px solid #18264f">
            <h3 class="textS centerVert" style="text-align: left">There are no zones</h3>
          </div>
          <div class="col-2" style="border-bottom: 1px solid #18264f">
          </div>
          <div class="col-2" style="border-bottom: 1px solid #18264f">
          </div>
          <div class="col-2" style="border-bottom: 1px solid #18264f">
          </div>
          <div class="col-2" style="border-bottom: 1px solid #18264f">
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
